/** Base classes for the e-dialog native dialog element. */
export const dialogBaseClass = "e-dialog fixed inset-0 z-50 items-center justify-center";
